import type { ReactNode } from "react";

import styles from "./banner.module.css";
import { cx } from "./cx";
import type { SectionTone } from "./section-tone";

export interface BannerProps {
  tone?: SectionTone | "accent";
  icon: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}

export function Banner({
  tone,
  icon,
  title,
  description,
  action,
  className,
}: BannerProps) {
  const isAccent = tone === "accent";
  const sectionTone = tone && tone !== "accent" ? tone : undefined;

  return (
    <div
      className={cx(styles.banner, isAccent && styles.toneAccent, className)}
      data-section={sectionTone}
    >
      <div className={styles.left}>
        <div className={styles.iconWrap}>{icon}</div>
        <div className={styles.text}>
          <p className={styles.title}>{title}</p>
          {description ? (
            <p className={styles.description}>{description}</p>
          ) : null}
        </div>
      </div>
      {action ? <div>{action}</div> : null}
    </div>
  );
}
